module.exports = __webpack_public_path__ + "fonts/OpenSans300.5f1338dd.woff";